<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <DataTable
      :data="personas"
      :columns="columnas"
      idField="idPersona"
      mensajeVacio="No hay personas registradas."
      :mostrarBotonNuevo="opcionMenu == 1"
      :mostrarEditar="opcionMenu == 1"
      :mostrarVer="false"
      :mostrarEliminar="false"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idPersona)"
    >
      <!-- ── Búsqueda por cédula y nombre ───────────────────────── -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="cedulaBusqueda"
            placeholder="Cédula..."
            style="width:130px"
            @input="clearFields('cedula')"
            @keyup.enter="buscar"
          />
        </div>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Nombre..."
            style="width:220px; text-transform:uppercase"
            @input="clearFields('nombre')"
            @keyup.enter="buscar"
          />
          <button class="btn btn-outline-primary btn-sm" @click="buscar" title="Buscar">
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>

      <!-- ── Acciones extra por fila ────────────────────────────── -->
      <template #acciones-fila="{ row }" v-if="opcionMenu == 1">
        <button
          class="btn btn-sm btn-outline-primary"
          @click="abrirEditar(row.idPersona)"
          title="Ver detalle"
        >
          <span class="material-icons" style="font-size:14px">open_in_new</span>
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="deletePersona(row.idPersona)"
          title="Eliminar"
        >
          <span class="material-icons" style="font-size:14px">delete</span>
        </button>
      </template>
    </DataTable>

    <!-- ══════════════════════════════════════════════════════════════
         WIZARD PASO 1: Datos de la Persona
    ═══════════════════════════════════════════════════════════════ -->
    <div
      class="modal fade"
      id="ventanaModalPaso1"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.idPersona" disabled />
                  </div>
                </div>
              </div>
              <!-- Tipo ID + Documento + Estado Civil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Tipo Id.</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.idTipoIden">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="t in tipoIdens" :value="t.idTipoIden" :key="t.idTipoIden">{{ t.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Documento</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.documento" style="text-transform:uppercase" required />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Estado Civil</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.idEstadoCivil">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="e in estadoCivils" :value="e.idEstadoCivil" :key="e.idEstadoCivil">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Fecha nacimiento + Sexo + Teléfono -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Fecha Nac.</label></div>
                  <div class="col-2">
                    <input type="date" class="form-control" v-model="datoPersona.fechaNac" required />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Sexo</label></div>
                  <div class="col-2">
                    <select class="form-select" v-model="datoPersona.sexo" required>
                      <option value="">Seleccione...</option>
                      <option value="M">Masculino</option>
                      <option value="F">Femenino</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Teléfono</label></div>
                  <div class="col-2">
                    <input type="text" class="form-control" v-model="datoPersona.telefono" required />
                  </div>
                </div>
              </div>
              <!-- Primer nombre + Segundo nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Primer Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerNombre" style="text-transform:uppercase" required />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Segundo Nombre</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoNombre" style="text-transform:uppercase" />
                  </div>
                </div>
              </div>
              <!-- Primer apellido + Segundo apellido -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Primer Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.primerApellido" style="text-transform:uppercase" required />
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Segundo Apellido</label></div>
                  <div class="col-4">
                    <input type="text" class="form-control" v-model="datoPersona.segundoApellido" style="text-transform:uppercase" />
                  </div>
                </div>
              </div>
              <!-- Localidad + Email -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Localidad</label></div>
                  <div class="col-4">
                    <select class="form-select" v-model="datoPersona.idLocalidad">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="l in localidads" :value="l.idLocalidad" :key="l.idLocalidad">{{ l.nombre }}</option>
                    </select>
                  </div>
                  <div class="col-2"><label class="form-label fw-bold">Email</label></div>
                  <div class="col-4">
                    <input type="email" class="form-control" v-model="datoPersona.email" required />
                  </div>
                </div>
              </div>
              <!-- Dirección -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Dirección</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoPersona.direccion" style="text-transform:uppercase" required />
                  </div>
                </div>
              </div>
              <!-- Más información (colapsable) -->
              <button type="button" class="btn btn-link btn-sm p-0" @click="mostrarBloque = !mostrarBloque">
                {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
              </button>
              <div v-if="mostrarBloque" class="mt-2">
                <div class="mb-3">
                  <div class="row">
                    <div class="col-2"><label class="form-label fw-bold">Fecha Registro</label></div>
                    <div class="col-10">
                      <input type="text" class="form-control" v-model="datoPersona.fechaReg" disabled />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-primary" @click.prevent="siguientePaso1" v-if="btnCrear">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">arrow_forward</span>
              Siguiente
            </button>
            <button type="button" class="btn btn-warning" @click.prevent="actualizarPersona" v-if="btnEditar">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         WIZARD PASO 2: Crear Usuario
    ═══════════════════════════════════════════════════════════════ -->
    <div
      class="modal fade"
      id="ventanaModalPaso2"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user"></i> Crear Usuario
              <small class="ms-2 opacity-75 fs-6">Paso 2 de 3</small>
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Perfil</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoUsuario.idPerfil" @change="actualizarDatosDesdePerfil">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="p in perfils" :value="p.idPerfil" :key="p.idPerfil">{{ p.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Nombre de usuario -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoUsuario.nombre" required />
                  </div>
                </div>
              </div>
              <!-- Clave -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Clave</label></div>
                  <div class="col-10">
                    <input type="password" class="form-control" v-model="datoUsuario.clave" required />
                  </div>
                </div>
              </div>
              <!-- Permisos -->
              <div class="mb-3">
                <label class="form-label fw-bold">Permisos del Usuario</label>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-check" v-for="p in permisosCol1" :key="p.field">
                      <input class="form-check-input" type="checkbox" :id="p.field"
                        v-model="datoUsuario[p.field]" :true-value="1" :false-value="0" />
                      <label class="form-check-label" :for="p.field">{{ p.label }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check" v-for="p in permisosCol2" :key="p.field">
                      <input class="form-check-input" type="checkbox" :id="p.field"
                        v-model="datoUsuario[p.field]" :true-value="1" :false-value="0" />
                      <label class="form-check-label" :for="p.field">{{ p.label }}</label>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-check" v-for="p in permisosCol3" :key="p.field">
                      <input class="form-check-input" type="checkbox" :id="p.field"
                        v-model="datoUsuario[p.field]" :true-value="1" :false-value="0" />
                      <label class="form-check-label" :for="p.field">{{ p.label }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click.prevent="anteriorPaso2">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">arrow_back</span>
              Anterior
            </button>
            <button type="button" class="btn btn-primary" @click.prevent="siguientePaso2">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">arrow_forward</span>
              Siguiente
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         WIZARD PASO 3: Establecer como Médico
    ═══════════════════════════════════════════════════════════════ -->
    <div
      class="modal fade"
      id="ventanaModalPaso3"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-md"></i> Establecer como Médico
              <small class="ms-2 opacity-75 fs-6">Paso 3 de 3</small>
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row justify-content-center mb-4">
              <div class="col-auto">
                <div class="form-check form-switch fs-5">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="registrarComoMedico"
                    v-model="registrarComoMedico"
                  />
                  <label class="form-check-label" for="registrarComoMedico">
                    Registrar como Médico
                  </label>
                </div>
              </div>
            </div>
            <form v-if="registrarComoMedico">
              <!-- Especialidad -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Especialidad</label></div>
                  <div class="col-10">
                    <select class="form-select" v-model="datoMedico.idEspecialidad">
                      <option disabled value="">Seleccione...</option>
                      <option v-for="e in especialidads" :value="e.idEspecialidad" :key="e.idEspecialidad">{{ e.nombre }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Documento -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2"><label class="form-label fw-bold">Documento</label></div>
                  <div class="col-10">
                    <input type="text" class="form-control" v-model="datoMedico.documento" style="text-transform:uppercase" required />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click.prevent="anteriorPaso3">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">arrow_back</span>
              Anterior
            </button>
            <button type="button" class="btn btn-success" @click.prevent="finalizarWizard">
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">check</span>
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import config          from "@/config";
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

// Definición centralizada de permisos por columna
const PERMISOS_COL1 = [
  { field: "moduloAdministracion", label: "Módulo Administración" },
  { field: "moduloAtencion",       label: "Módulo Atención"       },
  { field: "moduloFacturacion",    label: "Módulo Facturación"    },
  { field: "moduloDashboards",     label: "Módulo Dashboards"     },
];
const PERMISOS_COL2 = [
  { field: "menuParametros", label: "Menú Parámetros" },
  { field: "menuProcesos",   label: "Menú Procesos"   },
  { field: "menuReportes",   label: "Menú Reportes"   },
  { field: "menuAyuda",      label: "Menú Ayuda"      },
];
const PERMISOS_COL3 = [
  { field: "opcionConsulta",    label: "Opción Consulta"    },
  { field: "opcionOperaciones", label: "Opción Operaciones" },
  { field: "opcionDescarga",    label: "Opción Descarga"    },
  { field: "opcionMenu",        label: "Opción Menú"        },
  { field: "moduloAuditoria",   label: "Módulo Auditoría"   },
];

export default {
  name: "PersonaList",
  components: { Layout, Footer, DataTable },

  props: {
    p_idEmpresa: { type: Number, required: true },
  },

  data() {
    return {
      // ── Opciones de sesión ───────────────────────────────────
      opcionConsulta:    0,
      opcionOperaciones: 0,
      opcionDescarga:    0,
      opcionMenu:        0,

      // ── Lista ────────────────────────────────────────────────
      personas:          [],
      datoPersona:       {},
      responsePersona:   {},
      cedulaBusqueda:    "",
      nombreBusqueda:    "",

      // ── Wizard ───────────────────────────────────────────────
      datoUsuario:         {},
      datoMedico:          {},
      titulo:              "",
      btnCrear:            false,
      btnEditar:           false,
      modalWindow:         true,
      mostrarBloque:       false,
      registrarComoMedico: false,
      idSuscripcion:       0,

      // ── Listas auxiliares ────────────────────────────────────
      tipoIdens:    [],
      localidads:   [],
      estadoCivils: [],
      perfils:      [],
      especialidads:[],

      // ── Constantes de permisos para el template ──────────────
      permisosCol1: PERMISOS_COL1,
      permisosCol2: PERMISOS_COL2,
      permisosCol3: PERMISOS_COL3,
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Documento", field: "documento"      },
        { label: "Nombre",    field: "nombreCompleto" },
        { label: "Teléfono",  field: "telefono"       },
        { label: "E-mail",    field: "email"          },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.opcionConsulta    = parseInt(window.sessionStorage.getItem("opcionConsulta"),    10) || 0;
    this.opcionOperaciones = parseInt(window.sessionStorage.getItem("opcionOperaciones"), 10) || 0;
    this.opcionDescarga    = parseInt(window.sessionStorage.getItem("opcionDescarga"),    10) || 0;
    this.opcionMenu        = parseInt(window.sessionStorage.getItem("opcionMenu"),        10) || 0;
    this.getData();
    this.cargarAuxiliares();
    this.cargarSuscripcion();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.cedulaBusqueda = "";
      this.nombreBusqueda = "";
      api.get("/vwpersonas/idempresa/" + this.p_idEmpresa)
        .then(r => { this.personas = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar personas:", e));
    },

    clearFields(field) {
      if (field !== "cedula") this.cedulaBusqueda = "";
      if (field !== "nombre") this.nombreBusqueda = "";
    },

    buscar() {
      const idEmpresa = window.sessionStorage.getItem("idEmpresa");
      if (this.cedulaBusqueda) {
        api.get(`/vwpersonas/documento?documento=${this.cedulaBusqueda}&idempresa=${idEmpresa}`)
          .then(r => { this.personas = Array.isArray(r.data) ? r.data : []; })
          .catch(() => Swal.fire({ icon: "error", title: "Sin resultados", text: "No se encontraron datos." }));
      } else if (this.nombreBusqueda) {
        api.get(`/vwpersonas/nombrecompleto?nombrecompleto=${this.nombreBusqueda}&idempresa=${idEmpresa}`)
          .then(r => { this.personas = Array.isArray(r.data) ? r.data : []; })
          .catch(() => Swal.fire({ icon: "error", title: "Sin resultados", text: "No se encontraron datos." }));
      } else {
        this.getData();
      }
    },

    // ── Auxiliares con fetch + config (igual que el original) ─
    cargarAuxiliares() {
      const cargar = (path, campo) => {
        fetch(config.apiBaseUrl + path)
          .then(r => r.json())
          .then(d => { this[campo] = d; })
          .catch(e => console.error(`Error fetching ${campo}:`, e));
      };
      cargar("/vwtipoidens",    "tipoIdens");
      cargar("/vwlocalidads",   "localidads");
      cargar("/vwestadocivils", "estadoCivils");
      cargar("/vwperfils",      "perfils");
      cargar("/vwespecialidads","especialidads");
    },

    async cargarSuscripcion() {
      try {
        const r          = await api.get(`/vwsuscripcions/idempresa-estadosusc/${this.p_idEmpresa}/VIGENTE`);
        const suscripcion = r.data[0];
        if (suscripcion) this.idSuscripcion = suscripcion.idSuscripcion;
      } catch (e) {
        console.error("Error al obtener suscripción:", e);
      }
    },

    // ── Validaciones ──────────────────────────────────────────
    validarFormPersona() {
      const fields = ["idTipoIden","idLocalidad","idEstadoCivil","documento",
        "primerNombre","primerApellido","fechaNac","direccion","telefono","sexo","email"];
      const labels = ["Tipo Id.","Localidad","Estado Civil","Documento",
        "Primer Nombre","Primer Apellido","Fecha Nac.","Dirección","Teléfono","Sexo","Email"];
      return validarForm(this.datoPersona, fields, labels);
    },

    validarFormUsuario() {
      return validarForm(
        this.datoUsuario,
        ["idPerfil", "nombre", "clave"],
        ["Perfil", "Nombre", "Clave"]
      );
    },

    validarFormMedico() {
      return validarForm(
        this.datoMedico,
        ["idEspecialidad", "documento"],
        ["Especialidad", "Documento"]
      );
    },

    // ── CRUD Persona ──────────────────────────────────────────
    async actualizarPersona() {
      if (this.validarFormPersona() !== 1) return;
      try {
        await api.post("/personas", this.datoPersona);
        $("#ventanaModalPaso1").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Persona actualizada exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deletePersona(idPersona) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar persona?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/personas/" + idPersona);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Wizard paso 1 → 2 ─────────────────────────────────────
    async siguientePaso1() {
      if (this.validarFormPersona() !== 1) return;
      try {
        this.datoPersona.idEmpresa  = this.p_idEmpresa;
        this.datoPersona.tipoPersona = "N";
        const r              = await api.post("/personas", this.datoPersona);
        this.responsePersona = r.data;
        $("#ventanaModalPaso1").modal("hide");
        this.$nextTick(() => $("#ventanaModalPaso2").modal("show"));
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    anteriorPaso2() {
      $("#ventanaModalPaso2").modal("hide");
      this.$nextTick(() => $("#ventanaModalPaso1").modal("show"));
    },

    // ── Wizard paso 2 → 3 ─────────────────────────────────────
    async siguientePaso2() {
      if (this.validarFormUsuario() !== 1) return;
      try {
        this.datoUsuario.idUsuarioReg  = window.sessionStorage.getItem("idUsuario");
        this.datoUsuario.idEmpresa     = this.p_idEmpresa;
        this.datoUsuario.idPersona     = this.responsePersona.idPersona;
        this.datoUsuario.idSuscripcion = this.idSuscripcion;
        await api.post("/usuarios", this.datoUsuario);
        $("#ventanaModalPaso2").modal("hide");
        this.$nextTick(() => $("#ventanaModalPaso3").modal("show"));
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    anteriorPaso3() {
      $("#ventanaModalPaso3").modal("hide");
      this.$nextTick(() => $("#ventanaModalPaso2").modal("show"));
    },

    // ── Wizard paso 3 → finalizar ─────────────────────────────
    async finalizarWizard() {
      if (this.registrarComoMedico) {
        if (this.validarFormMedico() !== 1) return;
        try {
          this.datoMedico.idPersona = this.responsePersona.idPersona;
          await api.post(
            `/medicos?idEmpresa=${this.p_idEmpresa}&idSuscripcion=${this.idSuscripcion}`,
            this.datoMedico
          );
          $("#ventanaModalPaso3").modal("hide");
          Swal.fire({ icon: "success", title: "¡Correcto!", text: "Registro completado exitosamente." });
          this.getData();
        } catch {
          Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        }
      } else {
        $("#ventanaModalPaso3").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Registro completado exitosamente." });
        this.getData();
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow         = true;
      this.datoPersona         = {};
      this.datoUsuario         = {};
      this.datoMedico          = {};
      this.registrarComoMedico = false;
      this.titulo              = "Crear Persona";
      this.btnCrear            = true;
      this.btnEditar           = false;
      this.$nextTick(() => $("#ventanaModalPaso1").modal("show"));
    },

    async abrirModalEditar(idPersona) {
      this.modalWindow = true;
      this.titulo      = "Editar Persona";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp       = await api.get("/vwpersonas/" + idPersona);
        this.datoPersona = resp.data;
        if (this.datoPersona.fechaNac)
          this.datoPersona.fechaNac = this.datoPersona.fechaNac.slice(0, 10);
      } catch (e) {
        console.error("Error al cargar persona:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModalPaso1").modal("show"));
    },

    // ── Navegación ────────────────────────────────────────────
    abrirEditar(idPersona) {
      if (idPersona != null) this.$router.push("/personaform/" + idPersona);
    },

    // ── Permisos desde perfil ────────────────────────────────
    actualizarDatosDesdePerfil() {
      const perfil = this.perfils.find(p => p.idPerfil === this.datoUsuario.idPerfil);
      if (!perfil) return;
      [...PERMISOS_COL1, ...PERMISOS_COL2, ...PERMISOS_COL3].forEach(({ field }) => {
        this.datoUsuario[field] = perfil[field];
      });
    },
  },
};
</script>

<style src="@/assets/css/tablaHover.css" scoped></style>